import DrawerWrapper from '@components/drawer/drawer-wrapper';
import { usePOSWindowDrawerCtx } from '../pos-order-taking-window';
import { Stack, Tab } from '@mui/material';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { useState } from 'react';
import useResizeObserver from 'use-resize-observer';
import POSTaxPayerIndividualDatatable from './pos-tax-payer-individual-datatable';
import POSTaxPayerGroupDatatable from './pos-tax-payer-group-datatable';

const POSTableTaxPayerDetails = () => {
  const { tableDetailsTaxPayerDisclosure } = usePOSWindowDrawerCtx();
  const { isOpen, onClose } = tableDetailsTaxPayerDisclosure;
  const { ref, height } = useResizeObserver<HTMLDivElement>();

  const [tabValue, setTabValue] = useState('individual');

  const handleTabChange = (_e: React.SyntheticEvent, newValue: string) => {
    setTabValue(newValue);
  };

  const tabs = [
    {
      title: 'Individual',
      value: 'individual',
      content: <POSTaxPayerIndividualDatatable onClose={onClose} />,
    },
    {
      title: 'Group / Company',
      value: 'Group/Company',
      content: <POSTaxPayerGroupDatatable onClose={onClose} />,
    },
  ];

  return (
    <DrawerWrapper
      {...{
        open: isOpen,
        onClose,
        withHeader: {
          title: 'Tax Payer List',
          learnMore: () => {},
          sx: {
            zIndex: 10,
          },
        },
      }}
    >
      <Stack
        component='form'
        sx={{
          width: { xs: '100%', md: '800px' },
          height: '100%',
        }}
        // onSubmit={handleSubmit(onSubmit)}
      >
        <Stack sx={{ flex: 1 }}>
          {/*TAB CONTENT */}
          <Stack flex={1} sx={{ p: 2, pb: 1, flex: 1, gap: 2 }}>
            <TabContext value={tabValue}>
              <TabList
                onChange={handleTabChange}
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                {tabs.map(({ title, value }) => (
                  <Tab
                    key={value}
                    label={title}
                    value={value}
                    sx={{
                      fontSize: '14px',
                      textTransform: 'capitalize',
                      flex: 1,
                    }}
                  />
                ))}
              </TabList>
              {tabs.map(({ value, content }) => {
                if (value !== tabValue) return;
                return (
                  <TabPanel
                    ref={ref}
                    key={value}
                    value={value}
                    sx={{
                      display: 'flex',
                      flex: 1,
                      p: 0,
                    }}
                  >
                    <Stack
                      flex={1}
                      sx={{ width: '100%', maxHeight: `${height}px` }}
                    >
                      {content}
                    </Stack>
                  </TabPanel>
                );
              })}
            </TabContext>
          </Stack>
        </Stack>
      </Stack>
    </DrawerWrapper>
  );
};

export default POSTableTaxPayerDetails;
